export default __webpack_public_path__ + "static/media/image-confetti.67921b11.jpg";